/**
 * The links a command hands back (a card checkout, a supplier's file links): the command shell keeps its result
 * open to show them, since a summary toast would leave the person nothing to copy.
 */
import { formatShortDateOrDash } from "../formatters";
import type { CommandLink, CommandResult, CommandWarning } from "./contract";

/** The result's links, in the order the command gave them. */
export function resultLinksOf(result: CommandResult): CommandLink[] {
  return result.links ?? [];
}

/** The warnings a command gave, in order: what it did not do although it succeeded. */
export function resultWarningsOf(result: CommandResult): CommandWarning[] {
  return result.warnings ?? [];
}

/** The shell shows this result before closing: per-row outcomes, links to copy, or warnings to read. */
export function holdsResult(result: CommandResult): boolean {
  return (
    !!result.rows ||
    resultLinksOf(result).length > 0 ||
    resultWarningsOf(result).length > 0
  );
}

/** "valid until 13 Dec" (London date), or null for a link that does not expire. */
export function linkExpiry(link: CommandLink): string | null {
  return link.expires_at
    ? `valid until ${formatShortDateOrDash(link.expires_at)}`
    : null;
}

/** Every link at once, each under its label, for Copy all links. */
export function allLinksText(links: readonly CommandLink[]): string {
  return links.map((link) => `${link.label}\n${link.href}`).join("\n\n");
}
